import React from 'react';
import configureStore from './src/store/configStore';

const configureGlobalStates = () => {
  configureStore();
};

export const wrapRootElement = ({ element, props }) => {
  configureGlobalStates();
  return <div {...props}>{element}</div>;
};

export function registerServiceWorker() {
  return true;
}
